import type { Brand } from '@seek/melways-sites';

import { BRAND } from 'src/shared/constant';

type DataType = Record<string, Array<string | false>>;

export const useSubjects = (brand: Brand) => {
  const signIn = {
    [BRAND.seek]: 'Sign in / Password',
    [BRAND.jobsdb]: 'Login / Password',
    [BRAND.jobstreet]: 'Login / Password',
  };

  const jobMail = {
    [BRAND.seek]: 'JobMail',
    [BRAND.jobsdb]: 'Job recommendation emails',
    [BRAND.jobstreet]: 'Job recommendation emails',
  };

  const subjectList: DataType = {
    [signIn[brand]]: [
      'Forgot my username or password',
      'Sign in error',
      'My account has been blocked',
      'I didn’t receive my password reset e-mail',
      'Other',
    ],
    ['My Account']: [
      'Update account details',
      'Update my e-mail address',
      'Registration',
      'Applied Jobs',
      'Saved jobs',
      'Delete account',
      'Other',
    ],
    ['Job Search']: [
      brand === BRAND.seek && 'How does {brandName}’s search engine work?',
      'How to search for a job',
      'Job search issues/error',
      brand === BRAND.seek && 'Location search',
      brand === BRAND.seek && 'Salary',
      'Other',
    ],
    ['Applying for a job']: [
      'Application error',
      'How to apply',
      brand === BRAND.seek && 'Certsy',
      'Privacy & data protection',
      brand === BRAND.seek && 'International application / Visa queries',
      'Cover letter',
      'Withdrawal of application',
      'Follow up application',
      'Other',
    ],
    ['{brandName} Profile']: [
      'What is a {brandName} Profile',
      'Create or Upload a resumé',
      'Edit or Delete a resumé',
      'Update my profile',
      'My profile visibility',
      'Delete my profile',
      'Profile sent with application',
      'Other',
    ],
    ['Report a suspicious ad']: [
      'Report a suspicious ad',
      'Report a suspicious hirer',
    ],
    ['Email Issues']: [
      'I’ve stopped receiving e-mails',
      'I need to update my e-mail address',
      'Unsubscribe from emails',
      jobMail[brand],
      brand === BRAND.seek && 'Weekly Round-up',
      'Other',
    ],
    ['Other']: ['General feedback', 'Product feedback', 'Company Reviews'],
  };

  /* Remove any nullish/falsey values when reasons are removed due to locale */
  const filterList = () => {
    const newList: Record<string, string[]> = {};

    // eslint-disable-next-line guard-for-in
    for (const subject in subjectList) {
      newList[subject] = subjectList[subject].filter(Boolean) as string[];
    }

    return newList;
  };

  return { subjects: filterList() };
};
